import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CompliancePageUI from './CompliancePageUI'

class CompliancePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      compliance: null,
      defaultInterest: null,
      complianceCodeList: null,
      loan: null,
      //
      penalChargeUpdateMode: false,
      complianceUpdateMode: false,
      covenantUpdateMode: false,
      //
      emailCreated: false,
      filteredList: null,
      selectedFilter: 'all',
      createMode: false,
      createCurrentCompliancesErrorList: null,
      createCurrentCompliancesSuccessMsg: null,
      createCurrentCompliancesSubmitted: false,
      updateNumberOfNoticesErrorList: null,
      updateNumberOfNoticesSuccessMsg: null,
      updateNumberOfNoticesSubmitted: false,
    }
  }

  render() {
    return (
      <CompliancePageUI
        context={this.props.context}
        loan={this.state.loan}
        errorList={this.state.errorList}
        compliance={this.state.compliance}
        defaultInterest={this.state.defaultInterest}
        complianceCodeList={this.state.filteredList}
        selectedFilter={this.state.selectedFilter}
        onFilterChange={this.onFilterChange}
        yearMonth={this.state.yearMonth}
        onRefreshClick={this.onRefreshClick}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        //
        penalChargeUpdateMode={this.state.penalChargeUpdateMode}
        onPenalChargeUpdateClick={() => this.setState({ penalChargeUpdateMode: true })}
        onPenalChargeUpdateCancel={() => this.setState({ penalChargeUpdateMode: false })}
        //
        complianceUpdateMode={this.state.complianceUpdateMode}
        onComplianceUpdateClick={this.onComplianceUpdateClick}
        onComplianceUpdateCancel={() => this.setState({ complianceUpdateMode: false })}
        selectedLoanCompliance={this.state.selectedLoanCompliance}
        //
        covenantUpdateMode={this.state.covenantUpdateMode}
        onCovenantUpdateClick={this.onCovenantUpdateClick}
        onCovenantUpdateCancel={() => this.setState({ covenantUpdateMode: false })}
        //
        onCreateEmailClick={this.onCreateEmailClick}
        emailCreated={this.state.emailCreated}
        //
        createMode={this.state.createMode}
        onCreateComplianceClick={() => { this.setState({ createMode: true }) }}
        onCancelCreateCompliance={() => { this.setState({ createMode: false }) }}
        //current compliacne creation
        createCurrentCompliancesErrorList={this.state.createCurrentCompliancesErrorList}
        createCurrentCompliancesSuccessMsg={this.state.createCurrentCompliancesSuccessMsg}
        createCurrentCompliancesSubmitted={this.state.createCurrentCompliancesSubmitted}
        onCreateCurrentCompliancesClick={this.onCreateCurrentCompliancesClick}
        //update number of notices sent
        updateNumberOfNoticesErrorList={this.state.updateNumberOfNoticesErrorList}
        updateNumberOfNoticesSuccessMsg={this.state.updateNumberOfNoticesSuccessMsg}
        updateNumberOfNoticesSubmitted={this.state.updateNumberOfNoticesSubmitted}
        onUpdateNumberOfNoticesClick={this.onUpdateNumberOfNoticesClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getNonCompliances(context, '', '')
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  onPreviousClick = () => {
    let context = this.props.context
    this.getNonCompliances(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getNonCompliances(context, this.state.nextYear, this.state.nextMonth)
  }

  getNonCompliances(context, year, month) {
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month

    let cacheManager = new CacheManager({
      resource: `/api/su/v1/loans/${this.props.match.params.loanId}/compliances`,
      cacheKey: CacheKeys.Compliances(this.props.match.params.loanId, year, month),
      callback: this.getNonCompliancesCallback,
      ttlInSecs: 600,
    })
    cacheManager.getObject2(context, {}, { year: year, month: month })
  }

  getNonCompliancesCallback = (response) => {
    this.setState({
      compliance: response.compliance,
      defaultInterest: response.defaultInterest,
      // complianceCodeList: response.compliance?response.compliance.complianceCodeList:null,
      filteredList: response.compliance ? response.compliance.complianceCodeList : null,
      errorList: response.errorList,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    })
  }

  onCreateCurrentCompliancesClick = () => {
    this.setState({
      createCurrentCompliancesSubmitted: true
    })

    RestApiUtils.post(
      this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/currentCompliances`,
      this.onCreateCurrentCompliancesCallback,
      {}
    )
  }

  onCreateCurrentCompliancesCallback = (response) => {
    let createCurrentCompliancesErrorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        createCurrentCompliancesErrorList.push(error.message)
      })
    }

    this.setState({
      createCurrentCompliancesSuccessMsg: response.success,
      createCurrentCompliancesErrorList: createCurrentCompliancesErrorList,
      createCurrentCompliancesSubmitted: false
    })

    if (createCurrentCompliancesErrorList.length === 0) {
      setTimeout(() => {
        this.setState({ createCurrentCompliancesSuccessMsg: null })
        this.onRefreshClick()
      }, 3000)
    }
  }
  onUpdateNumberOfNoticesClick = () => {
    this.setState({
      updateNumberOfNoticesSubmitted: true
    })

    RestApiUtils.put(
      this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/compliances/updateNoticeCreated`,
      this.onUpdateNumberOfNoticesClickCallback,
      {}
    )
  }

  onUpdateNumberOfNoticesClickCallback = (response) => {
    let updateNumberOfNoticesErrorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        updateNumberOfNoticesErrorList.push(error.message)
      })
    }

    this.setState({
      updateNumberOfNoticesSuccessMsg: response.success,
      updateNumberOfNoticesErrorList: updateNumberOfNoticesErrorList,
      updateNumberOfNoticesSubmitted: false
    })

    if (updateNumberOfNoticesErrorList.length === 0) {
      setTimeout(() => {
        this.setState({ createCurrentCompliancesSuccessMsg: null })
        this.onRefreshClick()
      }, 3000)
    }
  }

  onComplianceUpdateClick = (event, loanComplianceId, legalLanguageCode) => {
    let selectedLoanCompliance = this.state.compliance.complianceCodeList
      .flatMap(complianceCode => complianceCode.clauseList
        .filter(c => c.loanComplianceId === loanComplianceId)
      )[0]

    if (selectedLoanCompliance) {
      selectedLoanCompliance.legalLanguageCode = legalLanguageCode;
      this.setState({ complianceUpdateMode: true, selectedLoanCompliance: selectedLoanCompliance })
    }
  }

  onCovenantUpdateClick = (event) => {
    const legalLanguageCode = event.currentTarget.getAttribute('data-id');

    const selectedLoanCompliance = this.state.compliance.complianceCodeList
      .flatMap(c => c.clauseList)
      .find(clause => clause.legalLanguageCode === legalLanguageCode);

    console.log('selectedLoanCompliance:', selectedLoanCompliance);

    this.setState({
      covenantUpdateMode: true,
      selectedLoanCompliance
    });
  };



  onFilterChange = (selectedOption) => {
    const selectedFilter = selectedOption.value
    this.setState({ selectedFilter }, this.applyFilter)
  }

  applyFilter = () => {
    const { compliance, selectedFilter } = this.state
    let filteredList = []

    const complianceCodeList = (compliance && compliance.complianceCodeList) ? compliance.complianceCodeList : []

    complianceCodeList.forEach(code => {
      if (code.clauseList) {
        const filteredClauses = code.clauseList.filter(clause => {
          if (selectedFilter === 'not_complied') {
            return clause.status === 'not_complied'
          } else if (selectedFilter === 'complied') {
            return clause.status === 'complied'
          }
          return true
        })
        if (filteredClauses.length > 0) {
          filteredList.push({
            ...code,
            clauseList: filteredClauses
          })
        }
      }
    })

    this.setState({ filteredList: filteredList })
  }

  // onCreateEmailClick = () => {
  //   let emailCreated = this.state.emailCreated
  //   if (emailCreated)
  //     return

  //   this.setState({
  //     emailCreateSuccessMsg: null,
  //     emailCreateErrorList: [],
  //     emailCreated: true
  //   })

  //   RestApiUtils.post(this.props.context,
  //     `/api/su/loans/${this.state.loan.loanId}/compliances/createEmail`,
  //     this.onCreateEmailCallback, {}
  //   )
  // }

  onCreateEmailClick = () => {
    let emailCreated = this.state.emailCreated
    if (emailCreated)
      return

    this.setState({
      emailCreateSuccessMsg: null,
      emailCreateErrorList: [],
      emailCreated: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.state.loan.loanId}/compliances/v2/createEmail`,
      this.onCreateEmailCallback, {}
    )
  }

  onCreateEmailCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      emailCreateSuccessMsg: response.success,
      emailCreateErrorList: errorList,
      emailCreated: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          emailCreateSuccessMsg: null
        })
        this.onRefreshClick()
      }, 1000)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Compliances(this.props.match.params.loanId, this.state.year, this.state.month))
    if (noBusy === 'noBusy') {
      this.getNonCompliances(context, this.state.year, this.state.month)
    }
    else
      this.setState({ loan: null, compliance: null, errorList: null, defaultInterest: {} },
        this.getLoan(context),
        this.getNonCompliances(context, this.state.year, this.state.month)
      )
  }
}

export default withRouter(CompliancePageSF)
